// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--2GCju","Icon":"Icon--3mlQq","Message":"Message--1o7i4","Smile":"Smile--1gFed"};